import { render, staticRenderFns } from "./UserTerms.vue?vue&type=template&id=5b693002&scoped=true&"
import script from "./UserTerms.vue?vue&type=script&lang=js&"
export * from "./UserTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b693002",
  null
  
)

export default component.exports